/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ClientCommandMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler = function() {
	/** @type {Array} Storage of command messages. Need to process in the right order (not reversed like other messages)*/
	this.replaybleCommandsQueue = [];
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CLIENT_COMMAND);
};
$hxClasses['com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler'] = com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","ClientCommandMessageHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * Processes all commands which were placed in queue after refresh of the page in reversed order.
 */
com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler.prototype.runCommands = function () {
	for (var i = 0; i < this.replaybleCommandsQueue.length; i++) {
		this.processCommand(this.replaybleCommandsQueue[i], true);
	}
	this.replaybleCommandsQueue = [];
};

/**
 * Parses client.command messages and execute these commands.
 * @param {com.inq.flash.messagingframework.Message} message which contains command
 * @param {Boolean} replay determines refresh of the page (need to restore visible results of already executed commands)
 */
com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler.prototype.processCommand = function (message, replay) {

	if (com.inq.flash.client.control.FlashPeer.isMultiChatSupported()) { //RTDEV-23774: For multiple window chat support
		var masterWindowId = message.getProperty(com.inq.flash.client.data.MessageFields.MASTER_WINDOW_ID);
		// This windowId comparison needs to be done for the first time and not during replay.
		if (!replay && masterWindowId != "" && masterWindowId != com.inq.flash.client.control.FlashVars.getWindowId()) {
			return;
		}
	}
    /** @type {?string} */
	var cmd = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CLIENT_CMD_PARAM);
	if(cmd == null || cmd == "") cmd = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CLIENT_COMMAND_PARAM);
	/** @type {string} */
	var pageURL = cmd;
	/** @type {string} */
	var sTarget = "inqNewWindow";
	/** @type {number} */
	var indx;
	/** @type {string} */
	var newCmdPr = "client_command";
    /** @type {string} */
    var CLIENT_FUNCTION = "client_function";
	/** @type {?Array} */
	var match;

	if(pageURL == "hide_input") {
		com.inq.flash.client.chatskins.SkinControl.hideInput();
		return;
	}
	/*  show_input */
	match = pageURL.match(/^show_input(\|(.*))?/);
	/** @type {boolean} */
	var isShowInput = match != null ? true : false;/* If match is null, then we do not have show_input */
	if(isShowInput) {
		/*  Capturing groups: 0 = whole string, 1 = "|...", 2 = string after the "|" */
		com.inq.flash.client.chatskins.SkinControl.showInput(match[2] == "true");
		return;
	}

	if(pageURL.indexOf(newCmdPr) == 0) {
		com.inq.flash.client.chatskins.SkinControl.executeCustomCommand(HxOverrides.substr(pageURL,newCmdPr.length,null));/*  pageURL contains cmdType + cmdParam*/
		return;
	}

	if((indx = pageURL.indexOf(" to ")) >= 0) {
		sTarget = HxOverrides.substr(pageURL,indx + 4,null);
		pageURL = HxOverrides.substr(pageURL,0,indx);
	}

    if(pageURL.indexOf(CLIENT_FUNCTION) == 0 && !replay) {
        com.inq.flash.client.chatskins.SkinControl.executeCustomCommand(
			JSON.stringify( {
				"cmdType": CLIENT_FUNCTION,
				"cmdParam": HxOverrides.substr(pageURL,CLIENT_FUNCTION.length,null).trim(),
				"functionName": sTarget.trim() } ));
        return;
    }

	/* if the URL is xform,
	 * then we want to use the XFrameWorker to control the visibility.
	 */
	if(pageURL == "xform") {
		/** @type {Array} */ 
		var paramPair = sTarget.split("|");/* Expect format of verb.layerid|url or just verb.layerid */
		/** @type {Array} */ 
		var namePair = paramPair[0].split(".");/* Expect format of verb.layerid */

		/*  Replace placeholder, if exists, with correct url. Else use url from paramPair. */
		var url = paramPair.length > 1 ? paramPair[1].split(com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler.XFORM_SERVER_PLACEHOLDER).join(com.inq.flash.client.control.FlashPeer.getXFormsDomain()) : null;

		/** @type {string} */
		var initiatorType = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_INITIATOR);
		/** @type {string} */
		var initiatorId = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_INITIATOR_ID);
		var initiator = {type: initiatorType, id: initiatorId};

		com.inq.flash.client.control.MinimizeManager.lastAgentMessage(null);

		if (replay && namePair[0] !== "video") {
			return;
		}

		switch (namePair[0]) {
			case "shrink":
				com.inq.flash.client.control.XFrameWorker.shrink(namePair[1]);
				break;
			case "grow":
				com.inq.flash.client.control.XFrameWorker.grow(namePair[1], url, null, initiator);
				break;
			case "hide":
				com.inq.flash.client.control.XFrameWorker.hideLayer(namePair[1]);
				break;
			case "show":
				com.inq.flash.client.control.XFrameWorker.showLayer(namePair[1], null, url, null, null, initiator);
				break;
			case "video": {
				var par = /\((.*?)\)/.exec(paramPair[0]);
				var layerId = /^(.*?)\(/.exec(namePair[1]);
				layerId = layerId && layerId.length > 1 ? layerId[1] : null;
				if (par && par.length > 1 && layerId) {
					if (replay && com.inq.flash.client.control.PersistenceManager.GetValue(XFRAMES,{ })[layerId] == "0") {
						return;
					} else {
						com.inq.flash.client.control.XFrameWorker.showVideoLayer(layerId, null, url, null, null, initiator, par[1]);
					}
				}
			}
				break;
			/*
				Open iFrame with given URL.
				ex. 'xform to iframe.canvasName(https://demo.touchcommerce.com)'
        	*/
			case "iframe": {
				var par = /\((.*?)\)/.exec(paramPair[0]);
				var layerId = /^(.*?)\(/.exec(namePair[1]);
				layerId = layerId && layerId.length > 1 ? layerId[1] : null;
				if (par && par.length > 1 && layerId) {
					com.inq.flash.client.control.XFrameWorker.showIFrameLayer(layerId, null, par[1], null, null, initiator, par);
				}
			}
				break;
		}
		return;
	}

	if (replay) {
		return;
	}

	haxe.Log.trace("doPushPage: extract target " + sTarget,{ fileName : "ClientCommandMessageHandler.hx", lineNumber : 66, className : "com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler", methodName : "processMessage"});

	if(sTarget == "skin") {
		com.inq.ui.SkinLoader.LoadNewSkin(pageURL);
		return;
	}

	if(sTarget == "forward") {
		if(!com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) return;
		/** @type {Window} */
		var win = window.parent;
		if(win.focus) win.focus();
		return;
	}

	if(pageURL.indexOf("goToPersistentChat") >= 0) {
		haxe.Log.trace("CHAT: Frameset Push, closing socket",{ fileName : "ClientCommandMessageHandler.hx", lineNumber : 107, className : "com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler", methodName : "processMessage"});
		this.getController().shutdownQuietly(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_CLIENT_COMMAND);
	}

	if (com.inq.flash.client.control.FlashVars.getFlashVars().persistentFrame) {
		this.executeUrlRedirect(pageURL, sTarget);
	} else if ("_inqPersistentChat" == sTarget)
		com.inq.flash.client.chatskins.SkinControl.enablePersistentChatButtonAndEstablishUrl(pageURL);
	else if ("flashForm" == sTarget)
		com.inq.flash.client.chatskins.SkinControl.PushEmbeddedForm();
	else if ("block-service" == sTarget)
		com.inq.flash.client.chatskins.SkinControl.blockService(pageURL);/*  pageURL contains block details: service and duration*/
	else {
		this.executeUrlRedirect(pageURL, sTarget);
	}
};

/**
 * Select and execute the proper url redirection method.
 *
 * If removeJSInMessages is true (XSS mode), do not allow blind URL redirections
 * Only use COMMAND-AGENT-REDIRECT busines rule events and hand off validation
 * and redirection action.
 *
 * @param {string} - pageURL
 * @param {string} - sTarget
 * @return {undefined}
 * */
com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler.prototype.executeUrlRedirect = function (pageURL, sTarget) {
	if (com.inq.flash.client.control.FlashPeer.getRemoveJSInMessages()) {
		this.fireAgentUrlRedirect(pageURL);
	} else {
		com.inq.flash.client.chatskins.SkinControl.PushToFrameset(pageURL, sTarget);
	}
};


/**
 * Processes client.command message.
 * If message contains flag 'replay', then this message will be placed in queue
 * to process them in correct order after last received message.
 * Otherwise, just executes this command.
 * @param message which needs to be processed
 */
com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler.prototype.processMessage = function(message) {
	/** @type {boolean} */
	var replay = "1" == message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY);
	/* Our command can come in from messageText (AKA: KEY_CLIENT_COMMAND_PARAM)
	 * or from chat.cmd (AKA: KEY_CLIENT_CMD_PARAM)
	 * If chat.cmd exists, it has the command and the messageText has the description
	 * Else messageText has the command
	 */
	if (replay) {
		this.replaybleCommandsQueue.push(message);
	} else {
		this.processCommand(message);
	}
};

/**
 * Fires a COMMAND-AGENT-REDIRECT business rule event if the given url is valid.
 *
 * @param {string} - urlToRedirectTo
 * @return {undefined}
 */
com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler.prototype.fireAgentUrlRedirect = function (urlToRedirectTo) {
	if (com.inq.flash.client.control.FlashPeer.isValidHttpUrl(urlToRedirectTo)) {
		com.inq.flash.client.chatskins.SkinControl.fireCustomEvent(
			"COMMAND-AGENT-REDIRECT",
			function () {
				return {
					url: urlToRedirectTo
				};
			}
		);
	} else {
		haxe.Log.trace("fireAgentUrlRedirect invalid url given:'" + urlToRedirectTo + "'");
	}
};

/** @private @type {com.inq.flash.client.data.Chat} */
com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler.prototype.chat = null;
/** @type {com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler} */
com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler;
/** @type {string} */
com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler.XFORM_SERVER_PLACEHOLDER = "${xformsServerUrl}";

